import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
export const openCloseAnimationTime = 500;
const transitionType = 'transform 200ms cubic-bezier(0, 0, 0.2, 1) !important';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    '@media (max-width: 1280px)': {
      left: 'auto',
      right: 0,
      width: '60%',
      transform: 'translateX(100%)',
      transition: transitionType,
    },
    '@media (max-width: 959px)': {
      paddingBottom: 80
    },
    backgroundColor: 'transparent',
  },
  appBar: {
    boxShadow: 'none',
    zIndex: 5,
    height: theme.space.headerMobileHeight,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    transform: 'none',
    transition: transitionType,
    backgroundColor: 'transparent',
    '&.MuiSlide-exit': {
      transform: 'translateY(-100%)',
      transition: transitionType
    },
    '&.MuiSlide-enter': {
      transform: 'none',
      transition: transitionType
    }

  }
}), { name: 'MobileMenuDrawer' });
